<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-input v-model="queryForm.gh" placeholder="工号 / 姓名" style="width: 180px;"></el-input>
            <el-select v-model="queryForm.bm" placeholder="所属部门" style="width: 180px;" clearable>
                <el-option v-for="(item, index) in deptItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.ssjys" placeholder="所属教研室" style="width: 180px;" clearable>
                <el-option v-for="(item, index) in teachGroupItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <!-- <el-input v-model="queryForm.xm" placeholder="姓名" style="width: 180px;"></el-input> -->
            <!-- <el-select v-model="queryForm.zzlx" placeholder="在职类型" style="width: 180px;" clearable>
                <el-option v-for="(item, index) in zzlxItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.dqztm" placeholder="在职状态" style="width: 180px;" clearable>
                <el-option v-for="(item, index) in jsdqztmItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select> -->
            <!--
            <el-select v-model="queryForm.sfyx" placeholder="状态" style="width: 180px;" clearable>
                <el-option v-for="(item, index) in yxztItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            -->

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;新建</el-button>
            <el-button @click="ydxx" type="primary"><i class="el-icon-info"></i>&nbsp;异动信息</el-button>
            <el-button v-if="syncDataVisible" @click="syncTeaData" type="primary"><i class="el-icon-refresh"></i>&nbsp;同步教职工信息</el-button>
            <el-button @click="teacherTemplete" type="primary"><i class="el-icon-download"></i>&nbsp;教师模板</el-button>
            <el-button @click="uploadJs" type="primary"><i class="el-icon-download"></i>&nbsp;教师导入</el-button>
            <el-button @click="exportJs" type="primary"><i class="el-icon-download"></i>&nbsp;教师导出</el-button>
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="工号" prop="gh" align="center"></el-table-column>
            <el-table-column label="姓名" prop="xm" align="center"></el-table-column>
            <!-- <el-table-column label="在职类型" prop="zzlxmc" align="center"></el-table-column>
            <el-table-column label="在职状态" prop="lbmc" align="center"></el-table-column> -->
            <el-table-column label="所属部门" prop="bmmc" align="center"></el-table-column>
            <el-table-column label="所属教研室" prop="ssjysmc" align="center"></el-table-column>
            <!--
            <el-table-column label="状态" prop="sfyx" align="center" width="150px">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.sfyx == 0" type="warning" size="small" @click="handleStatus(scope.$index, scope.row)">无效</el-button>
                    <el-button v-else type="success" size="small" @click="handleStatus(scope.$index, scope.row)">有效</el-button>
                </template>
            </el-table-column>
            -->
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click="modRec(scope.row)">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">
                        <i class="el-icon-document"></i>&nbsp;异动处理
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页区域 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 30 ,40 , 50]" :page-size="queryForm.rowNum"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 表单 -->
        <el-dialog class="customElRow" :title="CurdDialogTitle" :visible.sync="CurdDialogVisible" @close="closeCurdDialog" width="1040px" top="100px">
            <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="基础信息" name="baseInfo"></el-tab-pane>
                <el-tab-pane label="扩展信息" name="expandInfo"></el-tab-pane>
            </el-tabs>
            <!-- 基础信息表单 -->
            <div v-show="baseInfoVisible">
                <el-form ref="baseInfoForm" :model="curdForm" label-width="110px" label-position="left" :rules="CurdRules">
                    <el-row>
                        <el-col :span="16">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="姓名" prop="xm">
                                        <el-input v-model="curdForm.xm" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="工号" prop="gh">
                                        <el-input :disabled="modFlag" v-model="curdForm.gh" style="width: 200px">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item v-if="!modFlag" label="自动获取工号">
                                        <el-button type="success" size="mini" @click="loadGh">外聘</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="姓名拼音" prop="xmpy">
                                        <el-input v-model="curdForm.xmpy" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="曾用名" prop="cym">
                                        <el-input v-model="curdForm.cym" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="参加工作年月" prop="cjgzny">
                                        <el-date-picker v-model="curdForm.cjgzny" align="right" type="month"
                                            style="width: 200px" value-format="yyyy-MM" placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="性别" prop="xbm">
                                        <el-select v-model="curdForm.xbm" style="width: 200px" placeholder="请选择" clearable>
                                            <el-option v-for="(item, index) in xbmItem" :key="item.comboValue"
                                                :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="身份证件类型" prop="sfzjlxm">
                                        <el-select v-model="curdForm.sfzjlxm" placeholder="请选择" style="width: 200px" clearable>
                                            <el-option v-for="(item, index) in sfzjlxmItem" :key="item.comboValue"
                                                :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="身份证件号" prop="sfzjh">
                                        <el-input v-model="curdForm.sfzjh" style="width: 200px"
                                            onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="所属部门" prop="bm">
                                        <el-select v-model="deptCodes" placeholder="请选择" style="width: 200px;" multiple clearable>
                                            <el-option v-for="(item, index) in deptItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="所属教研室" prop="ssjys">
                                        <el-select v-model="teachGroups" placeholder="请选择" style="width: 200px;" multiple clearable>
                                            <el-option v-for="(item, index) in teachGroupItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="岗位等级" prop="gwdj">
                                        <el-input v-model="curdForm.gwdj" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="岗位名称" prop="gwmc">
                                        <el-input v-model="curdForm.gwmc" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12">
                                    <el-form-item label="在职类型" prop="zzlx">
                                        <el-select v-model="curdForm.zzlx" placeholder="请选择" style="width: 200px;" clearable>
                                            <el-option v-for="(item, index) in zzlxItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                            <el-row>
                                <!-- <el-col :span="12">
                                    <el-form-item label="聘用期限" prop="pyqx">
                                        <el-input v-model="curdForm.pyqx" style="width: 200px"></el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="12">
                                    <el-form-item label="是否行政兼职" prop="sfxzjz">
                                        <el-select v-model="curdForm.sfxzjz" placeholder="请选择" style="width: 200px;" clearable>
                                            <el-option v-for="(item, index) in sfztItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="是否外聘教师" prop="sfwpjs">
                                        <el-select v-model="curdForm.sfwpjs" placeholder="请选择" style="width: 200px;" clearable>
                                            <el-option v-for="(item, index) in sfztItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="职称" prop="zcm">
                                        <el-select v-model="curdForm.zcm" placeholder="请选择" style="width: 200px;" clearable>
                                            <el-option v-for="(item, index) in jszcItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="8">
                            <div style="margin-top:10px; text-align:center;">
                                <el-upload accept=".png,.jpeg,.jpg" class="avatar-uploader"
                                    ref="upload" action :http-request="uploadPhoto"
                                    :show-file-list=false :file-list="fileList" :disabled="photoFlag">
                                    <img v-if="imageUrl" :src="imageUrl" class="photoImg">
                                    <div v-else class="photoArea">
                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                    </div>
                                    <div v-show="photoFlag" slot="tip" class="el-upload__tip" style="text-align:center;color:#0000FF">工号生成后可上传照片</div>
                                    <div v-show="!photoFlag" slot="tip" class="el-upload__tip" style="text-align:center">点击照片区域上传</div>
                                    <div slot="tip" class="el-upload__tip" style="text-align:center">格式 png,jpeg,jpg</div>
                                    <div slot="tip" class="el-upload__tip" style="text-align:center">建议规格 240px*320px</div>
                                </el-upload>
                                <div style="width:100%; margin:10px; text-align:center;">
                                    <el-button type="danger" size="small" @click="delPhoto" :disabled="imageUrl==''">
                                        <i class="el-icon-delete"></i> 删除照片
                                    </el-button>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <!-- 扩展信息表单 -->
            <div v-show="expandInfoVisible">
                <el-form ref="expandInfoForm" :model="curdForm" label-width="100px" label-position="left" :inline="true">
                    <el-form-item label="出生年月" prop="csrq">
                        <el-date-picker v-model="curdForm.csrq" align="right" type="month" style="width: 200px" value-format="yyyy-MM" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="年龄" prop="nl">
                        <el-input v-model="curdForm.nl" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="国籍" prop="gjdqm">
                        <el-select v-model="curdForm.gjdqm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in gbdmItem" :key="index" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="籍贯" prop="jg">
                        <el-select v-model="curdForm.jg" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in csdmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="港澳台侨外" prop="gatqwm">
                        <el-select v-model="curdForm.gatqwm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in gatqdmItem" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="民族" prop="mzm">
                        <el-select v-model="curdForm.mzm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in mzdmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="政治面貌" prop="zzmmm">
                        <el-select v-model="curdForm.zzmmm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in zzmmdmItem" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="婚姻状况" prop="hyztm">
                        <el-select v-model="curdForm.hyztm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in hyzkmItem" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="入何党派" prop="rhdp">
                        <el-select v-model="curdForm.rhdp" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in dpdmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="年月" prop="ny">
                        <el-date-picker v-model="curdForm.ny" align="right" type="month" style="width: 200px"
                            value-format="yyyy-MM" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="健康状况" prop="jkzkm">
                        <el-select v-model="curdForm.jkzkm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in jkztmItem" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="血型" prop="xxm">
                        <el-select v-model="curdForm.xxm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in xxdmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="户口类别" prop="hklbm">
                        <el-select v-model="curdForm.hklbm" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in hkxzmItem" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="当前住址" prop="dqzz">
                        <el-input v-model="curdForm.dqzz" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业学校" prop="byxx">
                        <el-input v-model="curdForm.byxx" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业专业" prop="byzy">
                        <el-input v-model="curdForm.byzy" style="width: 200px"></el-input>
                    </el-form-item>
                    <el-form-item label="毕业时间" prop="bysjny">
                        <el-date-picker v-model="curdForm.bysjny" align="right" type="month" style="width: 200px"
                            value-format="yyyy-MM" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="学历" prop="xl">
                        <el-select v-model="curdForm.xl" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in xldmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学位" prop="xw">
                        <el-select v-model="curdForm.xw" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in xwdmItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="是否班主任" prop="sfbzr">
                        <el-select v-model="curdForm.sfbzr" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in sfztItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="双一流高校" prop="sfsylgx">
                        <el-select v-model="curdForm.sfsylgx" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in sfztItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否师范专业" prop="sfsfzy">
                        <el-select v-model="curdForm.sfsfzy" placeholder="请选择" style="width: 200px" clearable>
                            <el-option v-for="(item, index) in sfztItem" :key="item.comboValue" :value="item.comboValue"
                                :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注" prop="bz">
                        <el-input v-model="curdForm.bz" style="width: 870px"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="save">保存</el-button>
                <el-button @click="CurdDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 异动信息 -->
        <el-dialog title="异动信息" :visible.sync="dialogVisible" width="1000px" top="100px">
            <div class="filter-container">
                <el-input v-model="ydxxForm.gh" placeholder="工号" style="width: 250px;"></el-input>
                <el-input v-model="ydxxForm.xm" placeholder="姓名" style="width: 250px;margin-left: 10px;"></el-input>

                <el-button @click="ydxxHandleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
                <el-button @click="ydxxHandleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            </div>

            <!-- 列表区域 -->
            <el-table :data="ydxxTableData" v-loading.body="tableLoading" ref="materialTable"
                element-loading-text="信息加载中" stripe border fit highlight-current-row
                header-cell-class-name="tableHeadStyle" height="500px">
                <el-table-column label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        <span>{{(ydxxForm.pageNum - 1) * ydxxForm.rowNum + scope.$index + 1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="工号" prop="gh" align="center"></el-table-column>
                <el-table-column label="姓名" prop="xm" align="center"></el-table-column>
                <el-table-column label="原状态" prop="yzt" align="center"></el-table-column>
                <el-table-column label="异动类型" prop="ydlx" align="center"></el-table-column>
                <el-table-column label="异动日期" prop="ydrq" align="center"></el-table-column>
                <el-table-column label="异动原因" prop="ydyy" align="center"></el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination @size-change="ydxxHandleSizeChange" @current-change="ydxxHandlePageChange"
                    :current-page.sync="ydxxForm.pageNum" :page-sizes="[10, 20, 30 ,40 , 50]"
                    :page-size="ydxxForm.rowNum" layout="total, sizes, prev, pager, next, jumper" :total="ydxxTotal">
                </el-pagination>
            </div>
        </el-dialog>

        <!-- destroy-on-close=true -->
        <el-dialog title="异动处理" :visible.sync="ydclDialogVisible" width="600px" top="200px" @closed="closeYdcl">
            <el-form ref="ydclForm" :model="ydclForm" label-width="120px" label-position="left" :rules="ydclRules">
                <el-form-item label="工号" prop="gh">{{ ydclForm.gh }}</el-form-item>
                <el-form-item label="姓名" prop="xm">{{ ydclForm.xm }}</el-form-item>
                <el-form-item label="异动类型" prop="ydlxm">
                    <el-select v-model="ydclForm.ydlxm" placeholder="请选择" style="width: 100%" clearable>
                        <el-option v-for="(item, index) in jsdqztmItem" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="异动日期" prop="ydrq">
                    <el-date-picker v-model="ydclForm.ydrq" align="right" type="date" value-format="yyyy-MM-dd" style="width: 100%" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="异动原因" prop="ydyy">
                    <el-input type="textarea" v-model="ydclForm.ydyy" placeholder="请填写异动说明" style="width: 100%" maxlength="1000" :rows="5" show-word-limit>
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveYdcl">确 定</el-button>
                <el-button @click="ydclDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-upload v-show="false" ref="upload" accept=".xlsx, .xls" :file-list="fileList" action
                   :http-request="handleUpload" :show-file-list="false" multiple>
        </el-upload>
    </div>
</template>

<script>
    import { globalConfig } from "static/config";
    import { validateIdentityId } from "../../utils/validate";
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        data() {
            let checkIdentitytionId  = (rule, value, callback) => {
                let errorMsg = validateIdentityId(value);
                if (errorMsg != "") {
                    callback(new Error(errorMsg));
                }else{
                    callback();
                }
            };

            return {
                //列表数据
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    gh: null,
                    xm: null,
                    zzlx: null,
                    dqztm: null,
                    sfyx: null,
                    bm: null,
                    ssjys: null,
                },
                tableData: [],
                //表单
                curdForm: {
                    xm: null,
                    gh: null,
                    cjgzny: null,
                    xmpy: null,
                    cym: null,
                    xbm: null,
                    sfzjlxm: null,
                    sfzjh: null,
                    bm: null,
                    oriDept: null,
                    ssjys: null,
                    oriTeachGroup: null,
                    gwmc: null,
                    gwdj: null,
                    pyqx: null,
                    csrq: null,
                    nl: null,
                    gjdqm: null,
                    jg: null,
                    gatqwm: null,
                    mzm: null,
                    zzmmm: null,
                    hyztm: null,
                    rhdp: null,
                    ny: null,
                    jkzkm: null,
                    xxm: null,
                    hklbm: null,
                    dqzz: null,
                    byxx: null,
                    byzy: null,
                    bysjny: null,
                    xl: null,
                    xw: null,
                    sfbzr: null,
                    sfsylgx: null,
                    sfsfzy: null,
                    bz: null,
                    dqztm: null,
                    sfyx: null,
                    zplj: null,
                    oldksdjh: null,
                    oldxjh: null,
                    zzlx: null,
                    sfwpjs: '0',
                    sfxzjz: '0',
                    zcm: null,
                },
                deptCodes: null,
                teachGroups: null,
                total: null,
                CurdDialogTitle: "",
                CurdDialogVisible: false,
                //选中行的数据
                selectRowData: null,
                tableLoading: true,
                mainTableHeight: null,
                //下拉列表
                sfztItem: [],
                //有效状态
                yxztItem: [],
                //性别码
                xbmItem: [],
                //身份证件类型码
                sfzjlxmItem: [],
                //国别代码
                gbdmItem: [],
                //港澳台侨代码
                gatqdmItem: [],
                //民族代码
                mzdmItem: [],
                zzmmdmItem: [],
                //党派代码
                dpdmItem: [],
                //婚姻状况码
                hyzkmItem: [],
                //健康状态码
                jkztmItem: [],
                //血型代码
                xxdmItem: [],
                //户口性质码
                hkxzmItem: [],
                //城市代码
                csdmItem: [],
                //教师当前状态码
                jsdqztmItem: [],
                //在职类型
                zzlxItem: [],
                //学历代码
                xldmItem: [],
                //学位代码
                xwdmItem: [],
                //部门
                deptItem: [],
                //教研室
                teachGroupItem: [],
                //职称
                jszcItem: [],
                activeName: "baseInfo",
                dialogVisible: false,
                ydxxTableData: [],
                ydxxForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xm: null,
                    gh: null,
                    cdgh: null
                },
                ydxxTotal: null,
                ydclForm: {
                    gh: null,
                    xm: null,
                    ydrq: null,
                    ydyy: null,
                    yztm: null,
                    ydlxm: null
                },

                ydclDialogVisible: false,

                baseInfoVisible: true,
                expandInfoVisible: false,
                imageUrl: "",
                CurdRules: {
                    xm: [{
                        required: true,
                        message: "请填写姓名",
                    }],
                    gh: [{
                        required: true,
                        message: "请填写工号",
                    }],
                    // cjgzny: [{
                    //     required: true,
                    //     message: "请选择参加工作年月",
                    // }],
                    // sfzjh: [{
                    //     required: true,
                    //     message: "请填写身份证件号",
                    // },{
                    //     validator: checkIdentitytionId,
                    //     trigger: "blur",
                    // }],
                    // zzlx: [{
                    //     required: true,
                    //     trigger: ['blur','change'],
                    //     message: "请选择在职类型",
                    // }],
                },
                photoFlag: true,
                fileList: [],
                //异动处理校验
                ydclRules: {
                    ydlxm: [{
                        required: true,
                        trigger: ['blur','change'],
                        message: "请选择异动类型",
                    }],
                    ydrq: [{
                        required: true,
                        message: "请选择异动日期",
                    }],
                },
                syncDataVisible: false,
                syncDataMask: null,
                modFlag:false
            }
        },
        mounted() {
            this.syncDataVisible = globalConfig.syncDataVisible;
            this.queryList();
            this.item();

            this.$nextTick().then(() => {
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            loadGh(){
                this.$api.baseInfo.teacher.loadGh({}).then((res) => {
                    this.curdForm.gh = res.data.data
                }).catch((err) => {
                    console.log(err);
                });
            },
            teacherTemplete(){
                const fileName = 'teacherTemplate.xls'
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = "/static/template/" + fileName;
                link.setAttribute("download", '');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            handleUpload(param) {
                let formData = new FormData();
                formData.append('file', param.file);
                this.showLoadingMask("导入中,请稍后...")
                this.$api.baseInfo.teacher.upload({
                    data: formData
                }).then((res) => {
                    const newDatas = []
                    const h = this.$createElement
                    for (const i in res.data.data) {
                        newDatas.push(h('p', null, res.data.data[i]))
                    }
                    this.$alert('提示', {
                        title: '提示',
                        message: h('div', {
                            style: 'height:200px; overflow:auto;'
                        }, newDatas),
                        confirmButtonText: '确定',
                    });
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                    this.queryList();
                });;
            },
            uploadJs(){
                // 触发upload组件内部点击事件，弹出文件选择框
                this.$refs['upload'].$refs['upload-inner'].handleClick();
            },
            exportJs() {
                this.$api.baseInfo.teacher.export({
                    data: this.queryForm,
                    responseType: "blob",
                }).then((response) => {
                    const content = response.data;
                    const blob = new Blob([content]);
                    const fileName = "教师信息" + ".xlsx";
                    if ("download" in document.createElement("a")) {
                        // 非IE下载
                        const elink = document.createElement("a");
                        elink.download = fileName;
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                    }
                }).catch((err) => {

                });
            },
            queryList() {
                this.tableLoading = true;
                this.$api.baseInfo.teacher.queryList({
                        data: this.queryForm,
                    })
                    .then((res) => {
                        this.total = res.data.data.total;
                        this.tableData = res.data.data.list;
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                        this.tableLoading = false;
                        console.log(err);
                    });
            },
            //获取下拉列表数据
            item() {
                this.$api.baseInfo.teacher.item({}).then((res) => {
                    this.sfztItem = res.data.data.sfztItem;
                    this.yxztItem = res.data.data.yxztItem;
                    this.xbmItem = res.data.data.xbmItem;
                    this.sfzjlxmItem = res.data.data.sfzjlxmItem;
                    this.gbdmItem = res.data.data.gbdmItem;
                    this.gatqdmItem = res.data.data.gatqdmItem;
                    this.mzdmItem = res.data.data.mzdmItem;
                    this.zzmmdmItem = res.data.data.zzmmdmItem;
                    this.dpdmItem = res.data.data.dpdmItem;
                    this.hyzkmItem = res.data.data.hyzkmItem;
                    this.jkztmItem = res.data.data.jkztmItem;
                    this.xxdmItem = res.data.data.xxdmItem;
                    this.hkxzmItem = res.data.data.hkxzmItem;
                    this.csdmItem = res.data.data.csdmItem;
                    this.jsdqztmItem = res.data.data.jsdqztmItem;
                    this.xldmItem = res.data.data.xldmItem;
                    this.xwdmItem = res.data.data.xwdmItem;
                    this.zzlxItem = res.data.data.zzlxItem;
                    this.deptItem = res.data.data.dept;
                    this.teachGroupItem = res.data.data.teachGroup;
                    this.jszcItem = res.data.data.jszcItem;
                }).catch((err) => {
                    console.log(err);
                });
            },
            addRec(){
                this.modFlag = false
                this.curdForm.saveType = 'add'
                this.CurdDialogTitle = "新建";
                this.CurdDialogVisible = true;
                this.curdForm.oriDept = '';
                this.curdForm.oriTeachGroup = '';
                this.deptCodes = [];
                this.teachGroups = [];
            },
            modRec(rowData){
                this.modFlag = true
                this.curdForm.saveType = 'mod'
                this.selectRowData = rowData;
                this.CurdDialogTitle = "编辑";
                this.CurdDialogVisible = true;

                this.$nextTick().then(() => {
                    //基础信息
                    this.curdForm.xm = this.selectRowData.xm;
                    this.curdForm.gh = this.selectRowData.gh;
                    this.curdForm.xmpy = this.selectRowData.xmpy;
                    this.curdForm.cym = this.selectRowData.cym;
                    this.curdForm.cjgzny = this.selectRowData.cjgzny;
                    this.curdForm.xbm = this.selectRowData.xbm;
                    this.curdForm.sfzjlxm = this.selectRowData.sfzjlxm;
                    this.curdForm.sfzjh = this.selectRowData.sfzjh;
                    // this.curdForm.bm = this.selectRowData.bm;
                    if(this.selectRowData.bm && this.selectRowData.bm!=''){
                        this.deptCodes = this.selectRowData.bm.split(',');
                    }else{
                        this.deptCodes = [];
                    }
                    this.curdForm.oriDept = this.selectRowData.bm;
                    if(this.selectRowData.ssjys && this.selectRowData.ssjys!=''){
                        this.teachGroups = this.selectRowData.ssjys.split(',');
                    }else{
                        this.teachGroups = [];
                    }
                    this.curdForm.oriTeachGroup = this.selectRowData.ssjys;
                    this.curdForm.gwmc = this.selectRowData.gwmc;
                    this.curdForm.gwdj = this.selectRowData.gwdj;
                    this.curdForm.zzlx = this.selectRowData.zzlx;
                    this.curdForm.pyqx = this.selectRowData.pyqx;
                    this.curdForm.dqztm = this.selectRowData.dqztm;
                    this.curdForm.sfwpjs = this.selectRowData.sfwpjs;
                    this.curdForm.sfxzjz = this.selectRowData.sfxzjz;
                    this.curdForm.zcm = this.selectRowData.zcm;
                    this.photoFlag = false;
                    this.curdForm.zplj = this.selectRowData.zplj;
                    if (this.curdForm.zplj && this.curdForm.zplj!=='') {
                        this.imageUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + this.curdForm.zplj;
                    }
                    //扩展信息
                    this.curdForm.csrq = this.selectRowData.csrq;
                    this.curdForm.nl = this.selectRowData.nl;
                    this.curdForm.gjdqm = this.selectRowData.gjdqm;
                    this.curdForm.jg = this.selectRowData.jg;
                    this.curdForm.gatqwm = this.selectRowData.gatqwm;
                    this.curdForm.mzm = this.selectRowData.mzm;
                    this.curdForm.zzmmm = this.selectRowData.zzmmm;
                    this.curdForm.hyztm = this.selectRowData.hyztm;
                    this.curdForm.rhdp = this.selectRowData.rhdp;
                    this.curdForm.ny = this.selectRowData.ny;
                    this.curdForm.jkzkm = this.selectRowData.jkzkm;
                    this.curdForm.xxm = this.selectRowData.xxm;
                    this.curdForm.hklbm = this.selectRowData.hklbm;
                    this.curdForm.dqzz = this.selectRowData.dqzz;
                    this.curdForm.byxx = this.selectRowData.byxx;
                    this.curdForm.byzy = this.selectRowData.byzy;
                    this.curdForm.bysjny = this.selectRowData.bysjny;
                    this.curdForm.xl = this.selectRowData.xl;
                    this.curdForm.xw = this.selectRowData.xw;
                    this.curdForm.sfbzr = this.selectRowData.sfbzr;
                    this.curdForm.sfsylgx = this.selectRowData.sfsylgx;
                    this.curdForm.sfsfzy = this.selectRowData.sfsfzy;
                    this.curdForm.bz = this.selectRowData.bz;
                });
            },
            closeCurdDialog() {
                if(this.$refs['baseInfoForm'] !== undefined){
                    this.$refs['baseInfoForm'].clearValidate();
                    this.$refs['baseInfoForm'].resetFields();
                }
                if(this.$refs['expandInfoForm'] !== undefined){
                    this.$refs['expandInfoForm'].resetFields();
                }

                this.imageUrl = '';
                this.activeName = 'baseInfo';
                this.baseInfoVisible = true;
                this.expandInfoVisible = false;
                this.photoFlag = true;
            },
            save() {
                this.$refs['baseInfoForm'].validate((valid) => {
                    if (valid) {
                        this.curdForm.bm = this.deptCodes.toString();
                        this.curdForm.ssjys = this.teachGroups.toString();

                        this.$api.baseInfo.teacher.save({
                            data: this.curdForm,
                        }).then((res) => {
                            let state = res.data.data.state;
                            switch (state) {
                                case 'Succees':
                                    showNotify('成功', '保存成功', 'success', 1500);
                                    this.photoFlag = false;
                                    this.curdForm.gh = res.data.data.teaCode;
                                    this.curdForm.oriDept = this.curdForm.bm;
                                    this.curdForm.oriTeachGroup = this.curdForm.ssjys;
                                    this.selectRowData = this.curdForm;
                                    this.queryList();
                                    this.CurdDialogVisible = false
                                    break;
                                case 'Exist':
                                    showNotify('错误', '身份证件号已存在', 'error', 3000);
                                    break;
                                case 'ghExist':
                                    showNotify('错误', '工号已存在', 'error', 3000);
                                    break;
                                default:
                                    showNotify('错误', '保存失败', 'error', 3000);
                                    break;
                            }
                        }).catch((err) => {
                            console.log(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            ydxxList() {
                this.$api.baseInfo.teacher.ydxxList({
                        data: this.ydxxForm,
                    })
                    .then((res) => {
                        this.ydxxTotal = res.data.data.total;
                        this.ydxxTableData = res.data.data.list;
                        this.ydclDialogVisible = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.ydclDialogVisible = false;
                    });
            },
            ydxx() {
                this.ydxxForm.gh = null;
                this.ydxxForm.xm = null;
                this.dialogVisible = true;
                this.ydxxList();
            },
            handleReset() {
                this.queryForm.pageNum = 1;
                this.queryForm.rowNum = 10;
                this.queryForm.gh = null;
                this.queryForm.xm = null;
                this.queryForm.zzlx = null;
                this.queryForm.dqztm = null;
                this.queryForm.sfyx = null;
                this.queryForm.bm = null;
                this.queryForm.ssjys = null;
                this.tableLoading = false;
                this.queryList();
            },
            ydxxHandleReset() {
                this.ydxxForm.pageNum = 1;
                this.ydxxForm.rowNum = 10;
                this.ydxxForm.gh = null;
                this.ydxxForm.xm = null;
                this.tableLoading = false;
                this.queryList();
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handlePageChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
            },
            handleTabClick(tab, event) {
                if (tab.name == 'baseInfo') {
                    this.expandInfoVisible = false;
                    this.baseInfoVisible = true;
                } else {
                    this.baseInfoVisible = false;
                    this.expandInfoVisible = true;
                }
            },
            handleEdit(index, row) {
                this.ydclDialogVisible = true;
                this.ydclForm.gh = row.gh;
                this.ydclForm.xm = row.xm;
                this.ydclForm.yztm = row.dqztm;
                this.ydclForm.ydrq = null;
                this.ydclForm.ydlxm = null;
            },
            handleStatus(index, row) {
                this.curdForm.gh = row.gh;
                if (row.sfyx == 0) {
                    this.curdForm.sfyx = 1;
                } else {
                    this.curdForm.sfyx = 0;
                }
                this.$api.baseInfo.teacher.status({
                    data: this.curdForm,
                })
                .then((res) => {
                    this.queryList();
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            saveYdcl() {
                this.$refs['ydclForm'].validate((valid) => {
                    if (valid) {
                        this.$api.baseInfo.teacher.saveYdcl({
                            data: this.ydclForm,
                        })
                        .then((res) => {
                            let state = res.data.data.State;
                            switch (state) {
                                case 'Succees':
                                    this.ydclDialogVisible = false;
                                    this.queryList();
                                    showNotify('成功', '保存成功', 'success', 1500);
                                    break;
                                default:
                                    showNotify('错误', '保存失败', 'error', 3000);
                                    break;
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            closeYdcl(){
                if(this.$refs['ydclForm'] !== undefined){
                    this.$refs['ydclForm'].clearValidate();
                    this.$refs['ydclForm'].resetFields();
                }
            },
            //异动信息页码区域方法
            ydxxHandleSizeChange(val) {
                this.ydxxForm.rowNum = val;
                this.ydxxForm.pageNum = 1;
                this.ydxxList();
            },
            ydxxHandleFilter() {
                this.ydxxForm.pageNum = 1;
                this.ydxxList();
            },
            ydxxHandlePageChange(val) {
                this.ydxxForm.pageNum = val;
                this.ydxxList();
            },
            // 上传照片
            uploadPhoto(param) {
                let formData = new FormData();
                formData.append('files', param.file);
                formData.append('teaCode', this.curdForm.gh);
                formData.append('oriPhotoPath', this.curdForm.zplj);

                this.$api.baseInfo.teacher.uploadPhoto({
                    data: formData
                })
                .then((res) => {
                    this.updateRowPhotoInfo(res.data.data.path);
                    this.imageUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res.data.data.path;
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            //删除教师照片
            delPhoto() {
                confirmMsg('照片删除后无法恢复，是否确定要删除？').then(() => {
                    this.$api.baseInfo.teacher.delPhoto({
                        data: {
                            teaCode: this.curdForm.gh,
                            photoPath: this.curdForm.zplj,
                        },
                    }).then((res) => {
                        let state = res.data.data.state;
                        switch (state) {
                            case 'Succees':
                                showNotify('成功', '删除成功', 'success', 1500);

                                this.updateRowPhotoInfo();
                                this.imageUrl = "";
                                this.$refs['upload'].clearFiles();
                                break;
                            default:
                                showNotify('错误', '删除失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        this.formSubmiting = false;
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            updateRowPhotoInfo(photoPath = ''){
                this.curdForm.zplj = photoPath;
                this.selectRowData.zplj = photoPath;

                for(let i=0; i<this.tableData.length; i++){
                    if(this.tableData[i].gh = this.curdForm.gh){
                        this.tableData[i].zjlj = photoPath;
                    }
                }
            },
            syncTeaData(){
                this.showMaskLayer("教职工信息同步中...");
                this.$api.common.dataExchange.tea({
                    data: {}
                }).then(response => {
                    const state = res.data.data.state;
                    const msg = res.data.data.msg;

                    if(state == 'success'){
                        showNotify('成功', '同步成功', 'success', 1500);
                    }else{
                        showNotify('错误', msg ? msg : '同步失败', 'error', 3000);
                    }
                    this.closeMaskLayer();
                }).catch(error => {
                    console.log(error);
                    this.closeMaskLayer();
                });
            },
            showMaskLayer(str) {
                this.syncDataMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            closeMaskLayer() {
                if(this.syncDataMask) this.syncDataMask.close();
            },
        }
    };
</script>
<style scoped>
    .avatar-uploader-icon {
        font-size: 36px;
        color: #8c939d;
    }

    .photoImg {
        width: 192px;
        height: 256px;
        display: block;
    }

    .photoArea {
        width: 192px;
        height: 256px;
        line-height: 256px;
        border: 2px dashed #98a0aa;
        overflow: hidden;
    }

    .photoArea:hover {
        border: 2px dashed #409EFF;
    }

    .customElRow .el-row {
        padding-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// teacher.vue?556c8570